import { mapProduct } from 'helpers/algolia/map-product';
import { PRODUCT_RANGES } from 'helpers/constants/collection-names';
import { useParams } from 'next/navigation';
import React, { useCallback, useEffect } from 'react';
import { useStats, useHits } from 'react-instantsearch-hooks-web';

interface Props {
  setNumberOfHits?: any;
  setProductHits?: any;
  setProductQuery?: any;
  /** The raw InstantSearch results, lifted so the tastic can tell a zero-hit search from a pending one. */
  setProductResults?: any;
  searchQuery?: string;
}
const CustomStats: React.FC<Props> = ({
  setNumberOfHits,
  setProductHits,
  setProductQuery,
  setProductResults,
  searchQuery,
}) => {
  const { locale } = useParams();

  const { nbHits } = useStats();
  const { hits, results } = useHits();

  useEffect(() => {
    if (setNumberOfHits) setNumberOfHits(nbHits);
    if (setProductHits) {
        setProductHits(hits);
      }
  }, [nbHits]);

  useEffect(() => {
    if (setProductResults) setProductResults(results);
  }, [results, setProductResults]);

  useEffect(() => {
    if (setProductQuery && searchQuery) {
      setProductQuery('');
      if (hits?.length > 0) {
        const matchedProduct = hits?.find((hit) => {
          const mappedProduct = mapProduct(hit, locale, searchQuery);
          return mappedProduct?.selectedVariant;
        });
        if (matchedProduct) {
          const result = mapProduct(matchedProduct, locale, searchQuery);
          const range = result?.attributesAlgolia?.range?.toLowerCase();
          const productRanges = PRODUCT_RANGES.map((productRange) => productRange.toLowerCase());
          if (productRanges.includes(range)) {
            // Set product query for collections
            setProductQuery(result?.attributesAlgolia?.range);
          } else {
            // Set product query for categories
            setProductQuery(result?.categories?.[result?.categories?.length - 1]?.categoryId ?? '');
          }
        }
      } else {
        setProductQuery('');
      }
    }
  }, [searchQuery, setProductQuery, hits]);


  return <></>;
};

export default CustomStats;
